import React from "react";
import SideBar from "../components/sidebar-navbar";
import { containerStyle } from "../components/styles/styles";
import DashboardDoctorRoutes from "./wellnessDoctorRoute";
import DashboardIcon from "@material-ui/icons/Dashboard";
import GroupAddIcon from "@material-ui/icons/GroupAdd";
import CreditCardIcon from "@material-ui/icons/CreditCard";
import InboxIcon from "@material-ui/icons/MoveToInbox";
import EventAvailableIcon from "@material-ui/icons/EventAvailable";

import { SideBarLinks } from "../components/sidebar-navbar";

const sideBarOptionsContent = [
  {
    name: "Dashboard",
    url: "/wellness-doctor",
    icon: <DashboardIcon />,
  },
  {
    name: "Patients",
    url: "/wellness-doctor/patients",
    icon: <GroupAddIcon />,
  },
  {
    name: "Doctors",
    url: "/wellness-doctor/doctors",
    icon: <EventAvailableIcon />,
  },
  {
    name: "Telemedicine",
    url: "/wellness-doctor/telemedicine",
    icon: <InboxIcon />,
  },
  {
    name: "Transactions",
    url: "/wellness-doctor/transactions",
    icon: <CreditCardIcon />,
  },
  {
    name: "Switch Category",
    url: "/home",
    icon: <img src="/assets/switch-icon.png" alt="icon" />,
  },
];

const WellnessOnTheGoDashboard = () => {
  const classes = containerStyle();
  return (
    <div className={classes.root}>
      <SideBar
        iconButton
        drawerSection
        noFullAppBar
        logoOnClose
        appBarTitle="Wellness Doctor"
        // settings
        // settings_url="/hmo/dashboard/settings"
        sideBarOptions={sideBarOptionsContent.map((item, index) => {
          return (
            <SideBarLinks
              key={index}
              name={item.name}
              icon={item.icon}
              url={item.url}
            />
          );
        })}
      />
      <main className={classes.content}>
        <div className={classes.toolbar} />
        <DashboardDoctorRoutes />
      </main>
    </div>
  );
};

export default WellnessOnTheGoDashboard;
